var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPixelDraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 100,
    width: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5273.1 2400.1v-2c0-2.8-5-4-9.7-4s-9.7 1.3-9.7 4v2c0 1.8 0.7 3.6 2 4.9l5 4.9c0.3 0.3 0.4 0.6 0.4 1v6.4c0 0.4 0.2 0.7 0.6 0.8l2.9 0.9c0.5 0.1 1-0.2 1-0.8v-7.2c0-0.4 0.2-0.7 0.4-1l5.1-5C5272.4 2403.7 5273.1 2401.9 5273.1 2400.1zM5263.4 2400c-4.8 0-7.4-1.3-7.5-1.8v0c0.1-0.5 2.7-1.8 7.5-1.8 4.8 0 7.3 1.3 7.5 1.8C5270.7 2398.7 5268.2 2400 5263.4 2400z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5268.4 2410.3c-0.6 0-1 0.4-1 1 0 0.6 0.4 1 1 1h4.3c0.6 0 1-0.4 1-1 0-0.6-0.4-1-1-1H5268.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5272.7 2413.7h-4.3c-0.6 0-1 0.4-1 1 0 0.6 0.4 1 1 1h4.3c0.6 0 1-0.4 1-1C5273.7 2414.1 5273.3 2413.7 5272.7 2413.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5272.7 2417h-4.3c-0.6 0-1 0.4-1 1 0 0.6 0.4 1 1 1h4.3c0.6 0 1-0.4 1-1C5273.7 2417.5 5273.3 2417 5272.7 2417z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7 87.9H11.5V34.7h31.2l7.9-9H7c-2.5 0-4.5 2-4.5 4.5v62.2c0 2.5 2 4.5 4.5 4.5h62.2c2.5 0 4.5-2 4.5-4.5V50.9l-9 7.9V87.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6 69.9c-1.5 1.1-1 3.5 0.8 3.9 13 2.7 22.3-1.8 27.2-6.8 4.7-4.7 4.7-12.4 0-17.1 -4.7-4.7-12.4-4.7-17.1 0C28.5 55 31 63.6 22.6 69.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4 6.2C90.1 1.9 83 2.1 79 6.7L49.3 41c2.3 0.9 4.4 2.3 6.2 4.1 1.8 1.8 3.2 3.9 4.1 6.2l34.3-29.7C98.5 17.6 98.7 10.5 94.4 6.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixelDraw);
export default __webpack_public_path__ + "static/media/pixelDraw.9b05aee4f0717a40a21ff66e03dce3fe.svg";
export { ForwardRef as ReactComponent };